module.exports = __webpack_public_path__ + "static/media/current-prices.0e4b6265.png";